import React from 'react';
import { Sun, Moon, Monitor } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeToggle() {
  const { themeMode, setTheme } = useTheme();

  const options = [
    { key: 'light', icon: Sun, label: 'Light theme' },
    { key: 'system', icon: Monitor, label: 'System theme' },
    { key: 'dark', icon: Moon, label: 'Dark theme' },
  ];

  return (
    <div className="theme-toggle-group" role="group" aria-label="Theme selector">
      {options.map(({ key, icon: Icon, label }) => (
        <button
          key={key}
          className={`theme-toggle-btn ${themeMode === key ? 'active' : ''}`}
          onClick={() => setTheme(key)}
          title={label}
          aria-label={label}
          aria-pressed={themeMode === key}
        >
          <Icon size={16} />
        </button>
      ))}
    </div>
  );
}
